import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";

export default function SelectEstoqueCategorias({
    value,
    onChange,
    required = false,
    error = false,
    multiple = false,
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = (() => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value.map((item) => item.id).join(", ");
        } else {
            return `${value.id ?? ""}${value.nome ? ` - ${value.nome}` : ""}`;
        }
    })();

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Categoria`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, multiple }}
                        title="Selecionar categoria"
                        queryPath="/estoque/categoria/listar-todas"
                        defaultValue={
                            multiple
                                ? Array.isArray(value) && value.length > 0
                                    ? value
                                    : [defValueCategoriaEstoque]
                                : value
                                    ? value
                                    : defValueCategoriaEstoque
                        }
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        onChange={(value) => {
                            onChange(value as TCategoriaEstoque)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TCategoriaEstoque | TCategoriaEstoque[];
    onChange: (arg: TCategoriaEstoque | TCategoriaEstoque[] | null) => void
    required?: boolean
    error?: boolean
    multiple?: boolean
}

export interface TCategoriaEstoque {
    id: number;
    nome: string;
    categoria_id: number | null;
    atributos: string[];
    ordem: any[];
}

const defValueCategoriaEstoque: TCategoriaEstoque = {
    id: 0,
    nome: "",
    categoria_id: null,
    atributos: [],
    ordem: [],
};